import { Flex } from '@components';
import { Box, styled } from '@mui/material';

export const Container = styled(Box)(({ theme }) => ({
  maxHeight: '100vh',
  height: '100%',
  width: '100%',
  position: 'relative',
  background: theme.palette.common.white,
  overflow: 'hidden',
}));

export const MessageContainer = styled(Flex)(({ theme }) => ({
  height: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  flexDirection: 'column',
}));
